<template>
  <div class="footer-accordion border-b border-b-border py-3 tablet:border-b-0">
    <div
      v-blokkli-editable:field_title
      class="flex items-center justify-between text-size-6 font-bold"
      @click="isOpen = !isOpen"
    >
      <span>{{ title }}</span>
      <IconArrowToggle
        :open="isOpen"
        class="size-4 transition-transform duration-300 ease-bounce tablet:hidden"
      />
    </div>
    <VuepalTransitionHeight opacity>
      <div v-show="isOpen" class="footer-accordion-content tablet:!block">
        <BlokkliField
          name="field_paragraphs"
          :list="filterNullArray(paragraphs)"
          field-list-type="footerLinks"
          class="pt-3"
          :should-render-item
        />
      </div>
    </VuepalTransitionHeight>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphAccordionFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

defineProps<{
  title?: string
  paragraphs?: ParagraphAccordionFragment['paragraphs']
}>()

defineBlokkli({
  bundle: 'accordion',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  renderFor: {
    fieldListType: 'footer',
  },
})

const isOpen = ref(false)

const { shouldRenderItem } = useParagraphVisiblity()
</script>

<style lang="postcss">
.footer-accordion {
  &:has(.ck-content) {
    .ck-content {
      @apply text-size-6 desktop:max-w-[300px];
    }
  }
}
</style>
